import { PropsWithChildren } from 'react';

import { CFPGlobalProvider } from '@bcp-channels-sharedcomponents-reactjs/cf-proxy';
import { Debug } from '@bcp-channels-sharedcomponents-reactjs/core';
import { Language } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$types';
import { TLanguage } from '@bcp-channels-sharedcomponents-reactjs/utils';
import { css } from '@bcp-nextgen-dx-component-factory/design-system';
import { Accolade } from '@bcp-nextgen-dx-component-factory/theme-accolade';
import { Global, Interpolation, Theme } from '@emotion/react';
import { useURLSearchParams } from '@hooks';

import { ErrorBoundary } from './components';
import { LoggerConfig } from './configs';
import { LoggerOverlay, LoggerOverlayProvider } from './modules';
import { ErrorScreen } from './screens';

const globalStyles = css`
	* {
		box-sizing: border-box;
	}
` as Interpolation<Theme>;

export const AppProvider = ({ children }: PropsWithChildren) => {
	const { language } = useURLSearchParams().searchParams;

	return (
		<CFPGlobalProvider
			theme={Accolade}
			globalData={{
				company: 'bcp',
				language: (language || Language.pt) as TLanguage,
			}}
		>
			<LoggerOverlayProvider>
				{LoggerConfig.debug && (
					<>
						<Debug
							version={LoggerConfig.buildNumber}
							location={window.location.origin + window.location.pathname}
							hideEnvTag
							styles={{
								whiteSpace: 'nowrap',
								maxWidth: '200px',
							}}
						/>
						<LoggerOverlay />
					</>
				)}

				<Global styles={globalStyles} />

				<ErrorBoundary fallback={<ErrorScreen />}>{children}</ErrorBoundary>
			</LoggerOverlayProvider>
		</CFPGlobalProvider>
	);
};
